import Print from "vue-print-nb";
import Vue from 'vue'
import App from './App.vue'
//1.在 main.js 中导入路由模块
import router from '@/router/index.js'
import store from './store/index';

// 加载 element 组件库
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import "animate.css"

import 'bootstrap/dist/css/bootstrap.css' //引用bootstrap的样式
import 'bootstrap/dist/js/bootstrap.min.js' //引用bootstrap的js


import api from '@/common/request.js'

Vue.use(ElementUI)
Vue.use(Print);

Vue.prototype.$api = api;

Vue.config.productionTip = false




new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
